import styled from "styled-components";

export const DetailRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  color: #1D1D1D;
  min-height: 100vh;
  overflow-x: hidden;
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(40px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const DetailHeader = styled.div`
  width: 100%;
  max-width: 1440px;
  padding-bottom: 0;
  
  @media (max-width: 1920px) {
    padding-bottom: 0;
  }
`;

export const DetailTitle = styled.h1`
  color: #1D1D1D;
  font-size: 24px;
  font-family: 'Pretendard';
  font-weight: 700;
  line-height: 36px;
  word-wrap: break-word;
  margin: 0;
  
  @media (max-width: 1920px) {
    font-size: calc(24px * 100vw / 1920);
    line-height: calc(36px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 36px;
    word-break: keep-all;
  }
`;

export const DetailContent = styled.div`
  width: 100%;
  display: flex;
  gap: 80px;
  margin-top: 0;
  margin-bottom: 74px;
  
  @media (max-width: 1920px) {
    gap: calc(80px * 100vw / 1920);
    margin-bottom: calc(74px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    flex-direction: column;
    margin-bottom: 60px;
    gap: 40px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 0px;
    gap: 40px;
  }
`;

export const DetailImage = styled.div`
  width: 60%;
  border-radius: 16px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  
  @media (max-width: 1920px) {
    border-radius: calc(16px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const DetailInfo = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 17.4vw;
  padding-bottom: 0;
  justify-content: flex-start;
  box-sizing: border-box;
  overflow-x: hidden;
  
  @media (max-width: 1920px) {
    gap: 12.4vw;
    max-width: calc(100vw - 480px);
  }
  
  @media (max-width: 1700px) {
    gap: 200px;
    max-width: calc(100vw - 320px);
  }
  
  @media (max-width: 1600px) {
    gap: 150px;
  }
  
  @media (max-width: 1500px) {
    gap: 100px;
  }
  
  @media (max-width: 1440px) {
    max-width: calc(100vw - 160px);
  }
  
  @media (max-width: 1400px) {
    flex-direction: column;
    gap: 70px;
    padding: 0;
    margin-bottom: 70px;
    justify-content: flex-start;
    max-width: 100%;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 70px;
    padding: 0;
    margin-bottom: 70px;
    justify-content: flex-start;
    max-width: calc(100vw - 40px);
  }
`;

export const TitleInfo = styled.div`
  width: 396px;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 40px;
  display: inline-flex;
  flex-shrink: 0;
  
  @media (max-width: 1920px) {
    width: 496px;
    gap: calc(40px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    width: 100%;
    min-width: unset;
    max-width: 100%;
    gap: 30px;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
    gap: 30px;
  }
`;

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  
  @media (max-width: 1920px) {
    gap: calc(4px * 100vw / 1920);
  }
  
  @media (max-width: 1230px) {
    gap: 0;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    gap: 0px;
  }
`;

export const InfoItem = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  display: inline-flex;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    gap: calc(20px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    justify-content: flex-start;
    gap: 16px;
  }
`;

export const InfoLabel = styled.span`
  color: #999999;
  font-size: 12px;
  font-family: 'Montserrat';
  font-weight: 700;
  line-height: 16px;
  word-wrap: break-word;
  flex-shrink: 0;
  width: 80px;
  
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
    width: 72px;
  }
`;

export const InfoValue = styled.span`
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard';
  font-weight: 500;
  line-height: 28px;
  word-wrap: break-word;
  flex-shrink: 1;
  width: calc(100% - 80px);
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  text-align: left;
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
    width: calc(100% - 72px);
  }
`;

export const Description = styled.div`
  width: 710px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  flex-shrink: 1;
  min-width: 0;
  
  @media (max-width: 1920px) {
    width: 710px;
    gap: calc(40px * 100vw / 1920);
  }
  
  @media (max-width: 1700px) {
    width: auto;
    flex: 1;
  }
  
  @media (max-width: 1400px) {
    width: 100%;
    min-width: unset;
    max-width: 100%;
    gap: 24px;
    overflow: visible;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
    gap: 24px;
  }
`;

export const DescriptionText = styled.p`
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard';
  font-weight: 400;
  line-height: 26px;
  white-space: pre-wrap;
  width: 100%;
  overflow-wrap: break-word;
  margin-top: 0;
  
  /* h1, h2 태그에 구분선 추가 */
  h1, h2 {
    position: relative;
    padding-bottom: 16px;
    margin-bottom: 24px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #E0E0E0;
    }
  }
  
  h1 {
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    margin-top: 32px;
    
    @media (max-width: 1920px) {
      font-size: calc(24px * 100vw / 1920);
      line-height: calc(36px * 100vw / 1920);
      margin-top: calc(32px * 100vw / 1920);
      padding-bottom: calc(16px * 100vw / 1920);
      margin-bottom: calc(24px * 100vw / 1920);
    }
    
    @media (max-width: 768px) {
      font-size: 24px;
      line-height: 36px;
      margin-top: 32px;
      padding-bottom: 16px;
      margin-bottom: 24px;
    }
  }
  
  h2 {
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    margin-top: 28px;
    
    @media (max-width: 1920px) {
      font-size: calc(20px * 100vw / 1920);
      line-height: calc(30px * 100vw / 1920);
      margin-top: calc(28px * 100vw / 1920);
      padding-bottom: calc(16px * 100vw / 1920);
      margin-bottom: calc(24px * 100vw / 1920);
    }
    
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 30px;
      margin-top: 28px;
      padding-bottom: 16px;
      margin-bottom: 24px;
    }
  }
  
  @media (max-width: 1920px) {
    font-size: calc(16px * 100vw / 1920);
    line-height: calc(26px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    font-size: 16px;
    line-height: 26px;
    width: 100%;
  }

  @media (max-width: 768px) {
    margin-top: 46px;
    margin-bottom: 0px;
  }
`;

export const DescriptionContainer = styled.div`
  width: 100%;
`;

export const QuoteBlock = styled.blockquote`
  margin: 24px 0;
  padding: 0 0 0 24px;
  border-left: 4px solid #DCDCDC;
  position: relative;
  
  p {
    margin: 0;
    color: #666666;
    font-size: 16px;
    font-family: 'Pretendard';
    font-weight: 400;
    line-height: 26px;
  }
  
  /* 인용구 안의 모든 텍스트 요소들 */
  h1, h2, h3, h4, h5, h6 {
    color: #666666;
    margin: 16px 0 8px 0;
    
    &::after {
      display: none; /* 인용구 안에서는 구분선 제거 */
    }
  }
  
  h1 {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
  }
  
  h2 {
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
  }
  
  ul, ol {
    color: #666666;
    margin: 8px 0;
    padding-left: 20px;
  }
  
  li {
    color: #666666;
    font-size: 16px;
    font-family: 'Pretendard';
    font-weight: 400;
    line-height: 26px;
    margin: 4px 0;
  }
  
  strong, b {
    color: #666666;
    font-weight: 600;
  }
  
  em, i {
    color: #666666;
    font-style: normal; /* 기울임 제거 */
  }
  
  a {
    color: #666666;
    text-decoration: underline;
  }
  
  @media (max-width: 1920px) {
    margin: calc(24px * 100vw / 1920) 0;
    padding: 0 0 0 calc(24px * 100vw / 1920);
    
    p {
      font-size: calc(16px * 100vw / 1920);
      line-height: calc(26px * 100vw / 1920);
    }
    
    h1 {
      font-size: calc(20px * 100vw / 1920);
      line-height: calc(30px * 100vw / 1920);
    }
    
    h2 {
      font-size: calc(18px * 100vw / 1920);
      line-height: calc(28px * 100vw / 1920);
    }
    
    li {
      font-size: calc(16px * 100vw / 1920);
      line-height: calc(26px * 100vw / 1920);
    }
  }
  
  @media (max-width: 768px) {
    margin: 20px 0;
    padding: 0 0 0 20px;
    
    p {
      font-size: 16px;
      line-height: 24px;
    }
    
    h1 {
      font-size: 18px;
      line-height: 26px;
    }
    
    h2 {
      font-size: 16px;
      line-height: 24px;
    }
    
    li {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const RegularText = styled.div`
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard';
  font-weight: 400;
  line-height: 26px;
  white-space: pre-wrap;
  width: 100%;
  overflow-wrap: break-word;
  
  /* h1, h2 태그에 구분선 추가 */
  h1, h2 {
    position: relative;
    padding-bottom: 16px;
    margin-bottom: 24px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: #E0E0E0;
    }
  }
  
  h1 {
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    margin-top: 32px;
    
    @media (max-width: 1920px) {
      font-size: calc(24px * 100vw / 1920);
      line-height: calc(36px * 100vw / 1920);
      margin-top: calc(32px * 100vw / 1920);
      padding-bottom: calc(16px * 100vw / 1920);
      margin-bottom: calc(24px * 100vw / 1920);
    }
    
    @media (max-width: 768px) {
      font-size: 24px;
      line-height: 36px;
      margin-top: 32px;
      padding-bottom: 16px;
      margin-bottom: 24px;
    }
  }
  
  h2 {
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    margin-top: 28px;
    
    @media (max-width: 1920px) {
      font-size: calc(20px * 100vw / 1920);
      line-height: calc(30px * 100vw / 1920);
      margin-top: calc(28px * 100vw / 1920);
      padding-bottom: calc(16px * 100vw / 1920);
      margin-bottom: calc(24px * 100vw / 1920);
    }
    
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 30px;
      margin-top: 28px;
      padding-bottom: 16px;
      margin-bottom: 24px;
    }
  }
  
  @media (max-width: 1920px) {
    font-size: calc(16px * 100vw / 1920);
    line-height: calc(26px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    font-size: 16px;
    line-height: 26px;
    width: 100%;
  }

  @media (max-width: 768px) {
    margin-top: 46px;
    margin-bottom: 0px;
  }
`;

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  
  @media (max-width: 1920px) {
    gap: calc(12px * 100vw / 1920);
  }
  
  @media (max-width: 1400px) {
    width: 100%;
    gap: 10px;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    gap: 8px;
  }
`;

export const Tag = styled.div`
  padding: 10px 16px;
  background: #F0F0F0;
  border-radius: 50px;
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard';
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.01em;
  word-wrap: break-word;
  
  @media (max-width: 1920px) {
    padding: calc(10px * 100vw / 1920) calc(16px * 100vw / 1920);
    font-size: calc(16px * 100vw / 1920);
    line-height: calc(28px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const DetailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  @media (max-width: 1920px) {
    gap: calc(16px * 100vw / 1920);
  }
`;

export const DetailSectionTitle = styled.h3`
  font-size: 24px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  margin: 0;
  
  @media (max-width: 1920px) {
    font-size: calc(24px * 100vw / 1920);
  }
`;

export const DetailText = styled.p`
  font-size: 16px;
  font-family: 'Pretendard', sans-serif;
  line-height: 1.6;
  margin: 0;
  
  @media (max-width: 1920px) {
    font-size: calc(16px * 100vw / 1920);
  }
`;

export const DetailTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  
  @media (max-width: 1920px) {
    gap: calc(12px * 100vw / 1920);
  }
`;

export const DetailTag = styled.div`
  color: #999999;
  font-size: 16px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  
  @media (max-width: 1920px) {
    font-size: calc(16px * 100vw / 1920);
  }
`;

export const DetailGallery = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 50px;
  margin-bottom: 200px;
  opacity: 0;
  transform: translateY(40px);
  animation: fadeInUp 1s forwards;
  animation-delay: 0.3s;
  
  @media (max-width: 1920px) {
    gap: calc(50px * 100vw / 1920);
    margin-bottom: calc(200px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    gap: 20px;
    margin-bottom: 60px;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
  }
`;

export const GalleryImage = styled.div`
  width: 100%;
  overflow: hidden;
  
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    
    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }
`;

export const VideoSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 50px;
  margin-bottom: 200px;
  opacity: 0;
  transform: translateY(40px);
  animation: fadeInUp 1s forwards;
  animation-delay: 0.4s;
  margin-top: 0;
  
  @media (max-width: 1920px) {
    gap: calc(50px * 100vw / 1920);
    margin-bottom: calc(200px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    gap: 20px;
    margin-bottom: 60px;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
  }
`;

export const VideoWrapper = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  background: #F8F8F8;
  display: flex;
  align-items: center;
  justify-content: center;
  
  iframe {
    width: 100%;
    height: 100%;
  }
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const RelatedWorks = styled.div`
  width: 100%;
  max-width: 1440px;
  margin-bottom: 120px;
  opacity: 0;
  transform: translateY(40px);
  animation: fadeInUp 1s forwards;
  animation-delay: 0.5s;
  
  @media (max-width: 1920px) {
    margin-bottom: calc(120px * 100vw / 1920);
  }
`;

export const RelatedTitle = styled.h2`
  font-size: 36px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  margin-bottom: 40px;
  
  @media (max-width: 1920px) {
    font-size: calc(36px * 100vw / 1920);
    margin-bottom: calc(40px * 100vw / 1920);
  }
`;

export const RelatedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  
  @media (max-width: 1920px) {
    gap: calc(40px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const RelatedCard = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 20px;
  
  @media (max-width: 1920px) {
    gap: calc(20px * 100vw / 1920);
  }
`;

export const RelatedImage = styled.div`
  width: 100%;
  height: 240px;
  border-radius: 16px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
    transform-origin: center;
  }
  
  ${RelatedCard}:hover & img {
    transform: scale(1.05);
  }
  
  @media (max-width: 1920px) {
    height: calc(240px * 100vw / 1920);
    border-radius: calc(16px * 100vw / 1920);
  }
`;

export const RelatedCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  @media (max-width: 1920px) {
    gap: calc(8px * 100vw / 1920);
  }
`;

export const RelatedCardTitle = styled.h3`
  font-size: 18px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  @media (max-width: 1920px) {
    font-size: calc(18px * 100vw / 1920);
  }
`;

export const RelatedCardTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  
  @media (max-width: 1920px) {
    gap: calc(8px * 100vw / 1920);
  }
`;

export const RelatedCardTag = styled.div`
  color: #999999;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  
  @media (max-width: 1920px) {
    font-size: calc(14px * 100vw / 1920);
  }
`;

export const DetailBanner = styled.div`
  width: 100vw;
  height: 100vh;
  max-height: 1080px;
  position: relative;
  margin-bottom: 100px;
  opacity: 0;
  animation: bannerFadeIn 1s forwards;
  
  @keyframes bannerFadeIn {
    from {
      opacity: 0;
      transform: scale(1.05);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    width: 100vw;
    height: 0;
    padding-bottom: 100%;
    max-height: none;
    margin-bottom: 70px;
    margin-top: 56px;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;

export const DetailContainer = styled.div`
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 240px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    padding: 0 240px;
  }
  
  @media (max-width: 1700px) {
    padding: 0 160px;
  }
  
  @media (max-width: 1440px) {
    padding: 0 80px;
  }
  
  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const SeeMoreWorks = styled.div`
  width: 100%;
  padding: 120px 0 120px;
  background: #F8F8F8;
  
  @media (max-width: 1920px) {
    padding: calc(120px * 100vw / 1920) 0 calc(120px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    padding: 40px 0 80px;
  }
`;

export const SeeMoreContainer = styled.div`
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  display: flex;
  flex-direction: column;
  gap: 50px;
  padding: 0 240px;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    padding: 0 240px;
    gap: calc(50px * 100vw / 1920);
  }
  
  @media (max-width: 1700px) {
    padding: 0 160px;
  }
  
  @media (max-width: 1440px) {
    padding: 0 80px;
  }
  
  @media (max-width: 768px) {
    padding: 0 20px;
    gap: 10px;
  }
`;

export const SeeMoreHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    margin-bottom: 0px;
  }
`;

export const SeeMoreTitle = styled.h2`
  color: #1D1D1D;
  font-size: 48px;
  font-family: 'Montserrat';
  font-weight: 700;
  line-height: 70px;
  margin: 0;
  
  @media (max-width: 1920px) {
    font-size: calc(48px * 100vw / 1920);
    line-height: calc(70px * 100vw / 1920);
  }

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 40px;
    word-wrap: break-word;
    margin: 20px 0;
  }
`;

export const ViewMoreButton = styled.button`
  height: 60px;
  min-width: 160px;
  padding: 10px 30px;
  border-radius: 50px;
  border: 1px solid #DCDCDC;
  background: none;
  color: #1D1D1D;
  font-size: 16px;
  font-family: 'Pretendard';
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: none;
    color: #FF4F00;
    border-color: #FF4F00;
  }
  
  @media (max-width: 1920px) {
    height: calc(60px * 100vw / 1920);
    min-width: calc(160px * 100vw / 1920);
    padding: calc(10px * 100vw / 1920) calc(30px * 100vw / 1920);
    font-size: calc(16px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    height: 60px;
    width: 100%;
    min-width: unset;
    padding: 10px 30px;
    font-size: 16px;
    margin-top: 30px;
    align-self: stretch;
  }
`;

export const SeeMoreGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 90px 20px;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    row-gap: calc(90px * 100vw / 1920);
    column-gap: calc(20px * 100vw / 1920);
  }
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 60px 20px;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 50px;
    width: 100%;
    overflow: visible;
  }
`;

export const WorkCard = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  overflow: hidden;
  opacity: 0;
  transform: translateY(40px);
  animation: fadeInUp 1s forwards;
  box-sizing: border-box;
  
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
  &:nth-child(4) { animation-delay: 0.4s; }
  &:nth-child(5) { animation-delay: 0.5s; }
  &:nth-child(6) { animation-delay: 0.6s; }
  
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

export const WorkCardImageContainer = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: calc(187 / 335 * 100%);
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  
  @media (max-width: 1920px) {
    border-radius: calc(16px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    border-radius: 12px;
  }
`;

export const WorkCardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
  transform-origin: center;
  position: absolute;
  top: 0;
  left: 0;
  
  ${WorkCard}:hover & {
    transform: scale(1.1);
  }
`;

export const WorkCardContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
  
  @media (max-width: 1920px) {
    gap: calc(8px * 100vw / 1920);
    margin-top: calc(20px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    gap: 4px;
    margin-top: 12px;
  }
`;

export const WorkCardTitle = styled.h3`
  color: #1D1D1D;
  font-size: 32px;
  font-family: 'Pretendard';
  font-weight: 700;
  line-height: 46px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  
  @media (max-width: 1920px) {
    font-size: calc(32px * 100vw / 1920);
    line-height: calc(46px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const WorkCardTags = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  overflow: hidden;
  
  @media (max-width: 1920px) {
    gap: calc(16px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    gap: 10px;
    flex-wrap: nowrap;
    overflow: hidden;
    width: calc(100% - 15px);
    white-space: nowrap;
    position: relative;
    box-sizing: border-box;
    
    &:after {
      content: "...";
      position: absolute;
      right: -15px;
      bottom: 1px;
      display: inline-block;
      pointer-events: none;
      font-size: 14px;
      font-weight: 500;
      color: #999999;
      background-color: #F8F8F8;
      padding-left: 5px;
    }
  }
`;

export const WorkCardTag = styled.span`
  color: #999999;
  font-size: 16px;
  font-family: 'Montserrat';
  font-weight: 500;
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s ease;
  
  &:not(:last-child) {
    flex-shrink: 0;
  }
  
  &:last-child {
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  ${WorkCard}:hover & {
    color: #FF4F00;
  }
  
  @media (max-width: 1920px) {
    font-size: calc(16px * 100vw / 1920);
    line-height: calc(28px * 100vw / 1920);
  }
  
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
  }
`;

export const MobileTopNav = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    width: 100%;
    height: 60px;
    padding: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    background: white;
    z-index: 1000;
  }
`;

export const BackButton = styled.div`
  width: 56px;
  height: 56px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  svg {
    width: 24px;
    height: 24px;
    transform: rotate(-2deg);
    transform-origin: top left;
  }
`;

export const MobileTitle = styled.span`
  color: #1D1D1D;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 28px;
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 16px;
`;

export const PlaceholderIcon = styled.div`
  width: 56px;
  height: 56px;
`; 